import { ChangeDetectorRef, Component, Input, NgZone, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { SearchService } from '../../../shared/services/search.service';
import { Utility } from '../../../shared/entities/utils';
import { ColDef, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { NgxSpinnerService } from 'ngx-spinner';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import { MeasurementsDataService } from '../../../shared/services/measurements-data.service';
import { SplitterModule } from 'primeng/splitter';



export interface MaterialElementData {
  customerpo: string;
  coilid: string;
  nextstatus: string;
  expfindate: string;
  expdeldate: string;
  actshipdate: string;
  weight: string;
}

@Component({
  selector: 'app-material-data',
  standalone: true,
  imports: [AgGridModule, SplitterModule],
  templateUrl: './material-data.component.html',
  styleUrl: './material-data.component.scss'
})
export class MaterialDataComponent implements OnInit, OnChanges {
  @ViewChild('agGrid1', { static: true }) agGrid1?: AgGridAngular;
  @Input() orderPost: any;
  private gridApiMaterial!: GridApi;
  dataSourceMaterial: any;
  ELEMENT_DATA_MATERIAL: MaterialElementData[] = [];
  colDefsMaterial: ColDef[] = [];
  Unit: any;
  gridOptionsMaterial: GridOptions = {

    suppressCellFocus: true,
    suppressScrollOnNewData: true,
    suppressScrollWhenPopupsAreOpen: true

  };
  measuremntSystem: string = '';
  constructor(private _searchService: SearchService, private ngZone: NgZone, private spinner: NgxSpinnerService, private measurementsDataService: MeasurementsDataService, private cd: ChangeDetectorRef) {
    // this.spinner.show()
    this.Unit = this.measurementsDataService.regionMeasurementUnits()
    this.measurementsDataService.getMeasurementsData.subscribe((res: any) => {
      this.measuremntSystem = res;
    }
    )

  }
  ngOnChanges(changes: SimpleChanges): void {
    this.dataSourceMaterial = [];
    this.ELEMENT_DATA_MATERIAL = [];
    if (this.orderPost.customerReference) {
      this.ngZone.run(() => {
        this.getMaterialStatusData();
      });
    }

    this.cd.detectChanges();
  }
  onSortChangedMaterial(event: any) {
    const sortModelMaterial = event.api.sortController.getSortModel();
  }
  onGridReadyMaterial(params: GridReadyEvent) {
    this.gridApiMaterial = params.api;
  }


  coloumIntialization() {
    this.colDefsMaterial = [
      { field: "customerOrderNumber", headerName: "Customer PO", flex: 1 , wrapHeaderText:true ,autoHeaderHeight:true},
      { field: "coilSheetId", headerName: "Coil#", flex: 1, wrapHeaderText:true ,autoHeaderHeight:true },
      { field: "salesOrderNumber", headerName: "Order#", flex: 1 , wrapHeaderText:true ,autoHeaderHeight:true},
      { field: "nextStatus", headerName: "Next Status", flex: 1 , wrapHeaderText:true ,autoHeaderHeight:true},
      { field: "expectedFinishDate", headerName: "Expected Finish Date", flex: 1, wrapHeaderText:true ,autoHeaderHeight:true },
      { field: "expectedDeliveryDate", headerName: "Expected Delivery Date", flex: 1 , wrapHeaderText:true ,autoHeaderHeight:true},
      { field: "dateOfDelivery", headerName: "Actual shipment Date", flex: 1 , wrapHeaderText:true ,autoHeaderHeight:true},
      { field: "weight", headerName: `Weight (${this.Unit.weight})`, flex: 1 , wrapHeaderText:true ,autoHeaderHeight:true}
    ]
  }
  ngOnInit(): void {
    this.coloumIntialization()
    let oderPostVAlue;
    this._searchService.orderPost.subscribe(res => {
      oderPostVAlue = res;
    })
    if (oderPostVAlue) {
      this.orderPost = oderPostVAlue;
      this.getMaterialStatusData();
    }


  }
  getMaterialStatusData() {
    this._searchService.getOdinCoilStatusData(this.orderPost.customerReference).subscribe((res: any) => {
      res.content.forEach((element: any) => {
        element.weight =   element.weight? Utility.convertEUTonToUSTon(element.weight):'';
        this.ELEMENT_DATA_MATERIAL.push(element);
      });
      this.dataSourceMaterial = this.ELEMENT_DATA_MATERIAL;
    });
    this.cd.detectChanges()
  }

}
